import {gql} from 'graphql-request';
import {LogLevel} from '@/enums';
import {useMutation} from '@tanstack/react-query';
import {useGqlRequest} from './request';

export const useSendNcpLog = () => {
  const request = useGqlRequest({
    query: SEND_NCP_LOG,
  });

  const mutationFn = (
    content: {logLevel: LogLevel} & {[key: string]: any}
  ): Promise<{
    result?: any;
  }> => {
    return request({
      body: {
        logType: 'WEB',
        logSource: 'MYFCMAP',
        ...content,
      },
    });
  };

  return useMutation({
    mutationFn,
  });
};

const SEND_NCP_LOG = gql`
  mutation sendNcpLog($body: JSON!) {
    result: sendNcpLog(body: $body)
  }
`;
